import React from 'react'
import { TextField } from "@rmwc/textfield";
import "@rmwc/textfield/styles";
import { useFormik } from "formik";
import { useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { toAbsoluteUrl } from "../../../../Utils/_helpers";
import { APP_CONSTANT } from "../../../util/constants";
import * as auth from "../_redux/authRedux";

const initialValues = {
  email: "",
};

function ForgotPassword(props) {
  const { intl } = props;
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [isRequested, setIsRequested] = useState(false);
  const [resetEmail, setResetEmail] = useState(false);
  const [isSuccessResponse, setIsSuccessResponse] = useState(false);
  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string().required(
      intl.formatMessage({
        id: "Auth_validation-required-field",
      })
    ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const onResendClick = () => {
    formik.setStatus({ isSuccess: false, message: false });
    setIsSuccessResponse(false);
  };

  const handleSuccessMessage = (response) => {
    if (response.status === 200) {
      formik.setStatus({ isSuccess: true, message: response.success.message });
      setIsSuccessResponse(true);
    } else {
      formik.setStatus({ isSuccess: false, message: response.error.message });
    }
  };

  const handleErrorMessage = (response) => {
    formik.setStatus({ isSuccess: false, message: response.error.message });
  };

  const filledInputClass = (fieldname) => {
    if (formik.values[fieldname].length) {
      return "is-filled";
    }
    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      setResetEmail(values.email);
      dispatch(
        auth.actions.forgotPassword(
          { username: values.email },
          (response) => {
            handleSuccessMessage(response);
            setSubmitting(false);
            disableLoading();
          },
          (response) => {
            handleErrorMessage(response);
            setSubmitting(false);
            disableLoading();
          }
        )
      );
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div
          className="sr-login-form login-forgot"
          style={{ display: "block" }}
        >
          <div className="d-none d-lg-block">
            <img
              alt=""
              src={toAbsoluteUrl("/media/sr/logos/main-logo.svg")}
              className="main-logo"
            />
          </div>

          {isSuccessResponse && (
            <div className="after-reset-section">
              <div className="mb-8">
                <img
                  alt=""
                  src={toAbsoluteUrl("/media/sr/icons/send_mail.svg")}
                  className="reset_password-logo"
                />
              </div>

              <div>
                <p className="after-reset-title">
                  <FormattedMessage
                    id="Auth_forgot-reset-title-text"
                    defaultMessage="We have sent a password reset link to"
                  />
                  &nbsp;
                  <span className="resest-email">{resetEmail}</span>
                </p>
                <p className="reset-head-title">
                  <FormattedMessage
                    id="Auth_forgot-check-email"
                    defaultMessage="Check Your Email"
                  />
                </p>
              </div>

              <div className="mb-15">
                <p className="not-received-text">
                  Not Received? Check your spam folder or{" "}
                  <Link
                    to="/forgotPassword"
                    onClick={onResendClick}
                    className="link-clr"
                  >
                    <FormattedMessage
                      id="Auth_resend-button"
                      defaultMessage="Resend"
                    />
                  </Link>
                </p>
              </div>
              <Link to="/auth" className="w-100 btn btn-block sbt-btn">
                <FormattedMessage
                  id="Auth_login-button"
                  defaultMessage="Sign In"
                />
              </Link>
            </div>
          )}
          {!isSuccessResponse && (
            <div className="reset-section">
              <div>
                <img
                  alt=""
                  src={toAbsoluteUrl("/media/sr/icons/reset_password.svg")}
                  className="reset_password-logo"
                />
              </div>

              <div>
                <p className="reset-title">
                  <FormattedMessage
                    id="Auth_forgot-title"
                    defaultMessage="Reset Password"
                  />
                </p>
                <p className="forgot-sub-title">
                  <FormattedMessage
                    id="Auth_forgot-subtitle"
                    defaultMessage="Enter registered Username or Email"
                  />
                </p>
              </div>

              <form
                onSubmit={formik.handleSubmit}
                className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
              >
                {formik.status && formik.status.isSuccess && (
                  <div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
                    <div className="alert-text font-weight-bold">
                      {formik.status.message}
                    </div>
                  </div>
                )}

                <div className="fv-plugins-icon-container sr-first-input sr-form-input">
                  <TextField
                    label={intl.formatMessage({
                      id: "auth_input-username-title",
                      defaultMessage: "Username or Email",
                    })}
                    outlined="true"
                    className={` iemail sr-input-outline2 ${filledInputClass(
                      "email"
                    )}`}
                    icon={
                      <div className="pre-icon">
                        <img
                          alt=""
                          src={toAbsoluteUrl("/media/sr/icons/email.svg")}
                          className="email-icon"
                        />
                      </div>
                    }
                    name="email"
                    type="text"
                    {...formik.getFieldProps("email")}
                  ></TextField>

                  {(formik.isSubmitting || formik.touched.email) &&
                  (formik.touched ||
                    formik.values.email.length > 0 ||
                    formik.isSubmitting) &&
                  formik.errors.email ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.email}</div>
                    </div>
                  ) : null}
                  {formik.status && !formik.status.isSuccess && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.status.message}
                      </div>
                    </div>
                  )}
                </div>
                <div className="form-group d-flex flex-wrap flex-center">
                  <button
                    id="kt_login_forgot_submit"
                    type="submit"
                    disabled={formik.isSubmitting}
                    className={`btn btn-block sbt-btn forgot-password-btn mb-4`}
                  >
                    <span>
                      <FormattedMessage
                        id="Auth_forgot-submit-button"
                        defaultMessage="Send Reset Link"
                      />
                    </span>
                    {loading && (
                      <span className="ml-3 spinner spinner-white"></span>
                    )}
                  </button>

                  <Link
                    to="/auth"
                    className="w-100 link-clr text-center p-1 cacnel-lik"
                    id="kt_login_forgot_cancel"
                  >
                    <b>
                      <FormattedMessage
                        id="Auth_general-cancel-button"
                        defaultMessage="Cancel"
                      />
                    </b>
                  </Link>

                  <div className="powered-section text-center">
                    <a
                      target="_blank"
                      href={APP_CONSTANT.POWERED_BY_LINK}
                      rel="noreferrer"
                    >
                      <img
                        alt=""
                        src={toAbsoluteUrl("/media/sr/icons/powered-by.png")}
                        className="right-icon"
                      />
                    </a>
                  </div>
                  <div className="site-footer mt-4 mb-8 text-center d-block d-lg-none">
                    Copyright &#169; {APP_CONSTANT.COPYRIGHT_YEAR}, Knowlarity
                    Communications Pvt. Ltd | Powered by Knowlarity | &nbsp;
                    <a
                      href={APP_CONSTANT.SR_POLICY_LINK}
                      target="_blank"
                      className="link-clr"
                      rel="noreferrer"
                    >
                      Privacy Policy
                    </a>{" "}
                    | &nbsp;
                    <a
                      href={APP_CONSTANT.SR_TERMS_LINK}
                      target="_blank"
                      className="link-clr"
                      rel="noreferrer"
                    >
                      Terms &amp; Conditions
                    </a>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
